import React from 'react';
export const GeneralTableColumn = cell => {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
    className: "text-body font-weight-bold"
  }, cell));
};